import { Star } from "lucide-react";

const OUTLETS = [
  "Harvard Business Review",
  "Personality and Individual Differences",
  "Personality and Social Psychology Bulletin",
];

const Stat = ({ value, lines, testid }) => (
  <div data-testid={testid}>
    <p className="font-serif text-2xl lg:text-3xl text-[#D4AF37] leading-none">{value}</p>
    <p className="text-slate-500 text-xs mt-2 leading-relaxed">{lines}</p>
  </div>
);

export const HeroTrustStrip = ({ stats, review, onQuoteClick }) => {
  const quote = (review?.comment || "").trim();
  const short = quote.length > 96 ? `${quote.slice(0, 93).trimEnd()}…` : quote;

  return (
    <div
      className={`mt-12 pt-8 border-t border-slate-800 grid grid-cols-2 ${
        short ? "lg:grid-cols-4" : "lg:grid-cols-3"
      } gap-x-8 gap-y-7 animate-fadeInUp`}
      style={{ animationDelay: "0.35s" }}
      data-testid="hero-trust-strip"
    >
      <Stat
        testid="hero-stat-cases"
        value={stats?.cases ? stats.cases.toLocaleString() : "2,965"}
        lines={<>documented cases<br />across {stats?.countries || 40} countries</>}
      />
      <Stat
        testid="hero-stat-pubs"
        value="40+"
        lines={<>peer-reviewed studies<br />behind every strategy</>}
      />
      <div data-testid="hero-stat-outlets">
        <p className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2.5">In the literature</p>
        <ul className="space-y-1">
          {OUTLETS.map((outlet) => (
            <li key={outlet} className="text-slate-400 text-xs leading-snug">{outlet}</li>
          ))}
        </ul>
      </div>
      {short && (
        <button
          type="button"
          onClick={() => onQuoteClick(review)}
          className="text-left group"
          data-testid="hero-stat-quote"
        >
          <div className="flex gap-0.5 mb-2">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star
                key={n}
                size={12}
                className={n <= (review.rating || 5) ? "text-[#D4AF37] fill-[#D4AF37]" : "text-slate-700"}
              />
            ))}
          </div>
          <p className="text-slate-300 text-xs italic leading-relaxed group-hover:text-white transition-colors">
            “{short}”
          </p>
          <p className="text-slate-600 text-[10px] uppercase tracking-[0.2em] mt-2">
            {(review.client_name || "Client").split(" ")[0]} · verified client
          </p>
        </button>
      )}
    </div>
  );
};
